/* Keyboard access and the optional language suggestion. */
(function(){
  var bar = document.getElementById('glb-bar');
  var key = 'grig_language_dismissed_v1';
  if (bar) {
    var language = (navigator.language || '').slice(0, 2).toLowerCase();
    var suggestion = language === 'de' || language === 'fr' || language === 'cs'
      ? bar.querySelector('[data-glb-language="' + language + '"]') : null;
    var dismissed = false, chosen = false;
    try {
      dismissed = localStorage.getItem(key) === '1';
      chosen = localStorage.getItem('grig_lang_choice') !== null;
    } catch (error) {}
    if (suggestion && !dismissed && !chosen) { suggestion.hidden = false; bar.hidden = false; }
    bar.querySelector('.glb-close').addEventListener('click', function(){
      bar.hidden = true;
      try { localStorage.setItem(key, '1'); } catch (error) {}
      var next = document.querySelector('header.site a');
      if (next) next.focus();
    });
  }

  // What is scrolled into view in the page (a focused notice or control) clears the sticky header:
  // its scroll margin (grig.css) is the space the header takes where it sticks, below the offer
  // preview bar while that shows, kept in --grig-header-space. What is pinned below the header
  // (the /cart wait notice) follows where the header ends on screen now, kept in
  // --grig-header-bottom: lower while a bar above it (the announcement bar) is still in view, so
  // the header never covers it at any scroll position.
  var header = document.getElementById('hdr');
  function setVar(name, value){
    if (document.documentElement.style.getPropertyValue(name) !== value) document.documentElement.style.setProperty(name, value);
  }
  function headerSpace(){
    var rect = header.getBoundingClientRect();
    setVar('--grig-header-space', Math.ceil((parseFloat(getComputedStyle(header).top) || 0) + rect.height) + 'px');
    setVar('--grig-header-bottom', Math.max(0, Math.ceil(rect.bottom)) + 'px');
  }
  if (header) {
    // The header, and every bar above it: one that wraps, shows, goes or is added (an app's bar)
    // moves the header.
    var sized = 'ResizeObserver' in window ? new ResizeObserver(headerSpace) : null;
    var watchHeader = function(){
      if (sized) { sized.observe(header); for (var above = header.previousElementSibling; above; above = above.previousElementSibling) sized.observe(above); }
      headerSpace();
    };
    watchHeader();
    addEventListener('scroll', headerSpace, {passive:true});
    addEventListener('resize', headerSpace);
    new MutationObserver(watchHeader).observe(document.body, {attributes:true, attributeFilter:['class', 'style'], childList:true});
  }

  var menu = document.getElementById('mobileMenu');
  var hamburger = document.getElementById('hamburger');
  var consent = document.getElementById('consent');
  var drawer = document.getElementById('drawer');
  var scrim = document.getElementById('scrim');
  var toast = document.getElementById('toast');
  var mobile = matchMedia('(max-width: 1023px)');
  var active = null, previous = null, overflow = '';
  // The overlay layers (the cookie preferences, the mobile menu, a modal dialog, the cart drawer)
  // are told apart here, in one place, from what is on screen: every script asks GRIGLayers
  // which one is open, and only one opens at a time. The page beneath the open layer is inert,
  // drawn from that state each time it changes (never saved and restored per layer), so closing
  // one layer never gives back what another open one covers. What this script made inert is
  // remembered (covered) and given back once no layer covers it; the menu is inert while closed
  // as well (the drawer is, by grig.js).
  var covered = new Set();
  function menuOpen(){ return !!menu && mobile.matches && menu.classList.contains('open'); }
  function drawerOpen(){ return !!drawer && drawer.classList.contains('open'); }
  function preferencesOpen(){ return !!consent && consent.classList.contains('grig-consent-expanded') && getComputedStyle(consent).display !== 'none'; }
  function openLayer(){
    return preferencesOpen() ? 'preferences' : menuOpen() ? 'menu' : document.querySelector('dialog[open]') ? 'dialog' : drawerOpen() ? 'drawer' : null;
  }
  function focusable(root){
    return Array.from(root.querySelectorAll('a[href],button,input,select,textarea,[tabindex]'))
      .filter(function(el){ return !el.disabled && el.tabIndex >= 0 && !el.closest('[inert]') && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden'; });
  }
  // Everything beside the layer and beside each of its ancestors, but the scrim of the drawer
  // (it closes the drawer), the toast (a live region that tells an add made meanwhile) and
  // dialogs (modal themselves).
  function beside(layer){
    var nodes = new Set();
    for (var path = layer; path && path !== document.body && path.parentElement; path = path.parentElement) {
      Array.prototype.forEach.call(path.parentElement.children, function(el){
        if (el === path || el === toast || (layer === drawer && el === scrim) || /^(SCRIPT|STYLE|LINK|TEMPLATE|DIALOG)$/.test(el.tagName)) return;
        nodes.add(el);
      });
    }
    return nodes;
  }
  function sync(){
    var menuIsOpen = menuOpen(), drawerIsOpen = drawerOpen(), preferencesAreOpen = preferencesOpen();
    // The cookie preferences and the menu are modal here (focus moves into them and back);
    // the drawer moves focus itself (grig.js).
    var modal = preferencesAreOpen ? consent : menuIsOpen ? menu : null;
    var cover = beside(modal || (drawerIsOpen ? drawer : null));
    // Given back, the drawer is inert exactly while closed (it may have closed meanwhile).
    covered.forEach(function(el){ if (!cover.has(el)) { el.inert = el === drawer && !drawerIsOpen; covered.delete(el); } });
    cover.forEach(function(el){ if (el !== menu && !el.inert) { el.inert = true; covered.add(el); } });
    if (menu) menu.inert = !menuIsOpen || cover.has(menu);
    if (modal !== active) {
      var oldActive = active, returnFocus = previous;
      if (oldActive) document.body.style.overflow = overflow;
      active = modal;
      if (oldActive && returnFocus && returnFocus.isConnected && !returnFocus.closest('[inert]')) returnFocus.focus({preventScroll:true});
      if (active) {
        previous = document.activeElement;
        overflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        var first = focusable(active)[0];
        if (first) first.focus({preventScroll:true});
      } else previous = null;
    }
    // A cart or menu can cover the notice without accepting or rejecting cookies.
    if (consent) {
      var obscured = !preferencesAreOpen && !!(menuIsOpen || drawerIsOpen);
      if (consent.classList.contains('grig-consent-obscured') !== obscured) consent.classList.toggle('grig-consent-obscured', obscured);
    }
  }
  window.GRIGLayers = {
    // The overlay layer open now ('preferences', 'menu', 'dialog' or 'drawer'), or null.
    get open(){ return openLayer(); },
    // Draws the inert page again at once (a script that just opened or closed a layer).
    sync:sync
  };
  // The header language switcher (layout/theme.liquid) is a disclosure: its button opens the list
  // of languages and keeps focus; Tab or the arrow keys move through the languages, Escape closes
  // the list and gives focus back to the button, a click or tap outside or focus moving on closes
  // it. It is not an overlay layer of its own: it opens only while none is open and closes as soon
  // as one opens (the cookie preferences, the menu, a dialog, the drawer) or the snacks menu does,
  // watched only while it is open. A language submits the localization form natively.
  var langForm = document.getElementById('hdr-loc');
  var langToggle = document.getElementById('glang-toggle');
  var langList = document.getElementById('glang-list');
  if (langForm && langToggle && langList) {
    var snacks = document.getElementById('gmn-panel');
    var langWatch = null;
    var languages = function(){ return Array.prototype.slice.call(langList.querySelectorAll('.glang-option')); };
    var closeLanguages = function(returnFocus){
      if (langList.hidden) return;
      langList.hidden = true;
      langToggle.setAttribute('aria-expanded', 'false');
      if (langWatch) { langWatch.disconnect(); langWatch = null; }
      if (returnFocus) langToggle.focus({preventScroll:true});
    };
    var openLanguages = function(){
      if (!langList.hidden) return true;
      if (openLayer() || langToggle.closest('[inert]')) return false;
      langList.hidden = false;
      langToggle.setAttribute('aria-expanded', 'true');
      langWatch = new MutationObserver(function(){
        if (openLayer() || (snacks && !snacks.hidden)) closeLanguages(false);
      });
      langWatch.observe(document.body, {subtree:true, attributes:true, attributeFilter:['class', 'open', 'hidden']});
      return true;
    };
    var focusLanguage = function(item){
      if (!item) return;
      item.focus({preventScroll:true});
      // Kept in view inside the list (it scrolls on a short screen), never by scrolling the page.
      var top = item.offsetTop, bottom = top + item.offsetHeight;
      if (top < langList.scrollTop) langList.scrollTop = top;
      else if (bottom > langList.scrollTop + langList.clientHeight) langList.scrollTop = bottom - langList.clientHeight;
    };
    langToggle.addEventListener('click', function(){
      if (langList.hidden) openLanguages(); else closeLanguages(false);
    });
    document.addEventListener('click', function(event){
      if (!langList.hidden && !langForm.contains(event.target)) closeLanguages(false);
    });
    langForm.addEventListener('focusout', function(event){
      if (event.relatedTarget && !langForm.contains(event.relatedTarget)) closeLanguages(false);
    });
    document.addEventListener('keydown', function(event){
      if (event.key !== 'Escape' || langList.hidden) return;
      event.preventDefault();
      closeLanguages(true);
    });
    langForm.addEventListener('keydown', function(event){
      var key = event.key, items = languages(), index = items.indexOf(document.activeElement);
      if (!items.length || !/^(ArrowDown|ArrowUp|Home|End)$/.test(key)) return;
      if (document.activeElement === langToggle) {
        if (key !== 'ArrowDown' && key !== 'ArrowUp') return;
        event.preventDefault();
        if (openLanguages()) focusLanguage(key === 'ArrowDown' ? items[0] : items[items.length - 1]);
        return;
      }
      if (index < 0) return;
      event.preventDefault();
      focusLanguage(key === 'Home' ? items[0] : key === 'End' ? items[items.length - 1]
        : items[(index + (key === 'ArrowDown' ? 1 : items.length - 1)) % items.length]);
    });
    // A page restored from the back/forward cache starts with the list closed.
    addEventListener('pageshow', function(event){ if (event.persisted) closeLanguages(false); });
  }

  var observer = new MutationObserver(sync);
  [menu, consent, drawer].filter(Boolean).forEach(function(el){
    observer.observe(el, {attributes:true, attributeFilter:['class','style']});
  });
  mobile.addEventListener('change', function(){
    if (!mobile.matches && menu && hamburger) {
      menu.classList.remove('open');
      hamburger.classList.remove('open');
      hamburger.setAttribute('aria-expanded', 'false');
    }
    sync();
  });
  document.addEventListener('keydown', function(event){
    if (!active) return;
    if (event.key === 'Escape' && active === menu) {
      document.getElementById('mobileClose').click();
    }
    if (event.key === 'Escape' && active === consent) {
      event.preventDefault();
      var close = document.getElementById('ckClose');
      if (close) close.click();
    }
    if (event.key !== 'Tab') return;
    var items = focusable(active), first = items[0], last = items[items.length - 1];
    if (!first) { event.preventDefault(); return; }
    if (!active.contains(document.activeElement)) { event.preventDefault(); first.focus(); }
    else if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  sync();
  var result = document.querySelector('[data-gw-result]');
  if (result) result.focus();
})();
